import { wordings } from '@/constants/wordings';

export default (_, inject) => {
  inject('wordings', wordings);
};
